export const apiUrl = 'https://api.cricapi.com/v1/cricScore';
export const apiKey = 'ab12eb5d-64bd-40fe-8b1c-bd49af32eddd';
export const img = 'https://h.cricapi.com/img/icon512.png'
export   const handleRedirect = () => {
    window.open('https://mywalink.link/drwebsite', '_blank');
  };
